import { render, staticRenderFns } from "./EducationClassicPayPreview.vue?vue&type=template&id=5bbd2e10&scoped=true"
import script from "./EducationClassicPayPreview.vue?vue&type=script&lang=ts"
export * from "./EducationClassicPayPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd2e10",
  null
  
)

export default component.exports